import { render, staticRenderFns } from "./ReleaseBundleComparator.vue?vue&type=template&id=f6c6fa38&scoped=true"
import script from "./ReleaseBundleComparator.vue?vue&type=script&lang=js"
export * from "./ReleaseBundleComparator.vue?vue&type=script&lang=js"
import style0 from "./ReleaseBundleComparator.vue?vue&type=style&index=0&id=f6c6fa38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c6fa38",
  null
  
)

export default component.exports